import api from './client';

// POST /contact — send a public contact-form message to hello@mydrai.co.
// Returns whatever the API returns (usually { received: true }).
export async function submitContact(payload) {
  const res = await api.post('/contact', payload);
  return res?.data?.data ?? res?.data ?? null;
}
